import { NgModule } from '@angular/core';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { DiscoverComponent } from './components/Discover/discover.component';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { DiscoverLeftSidebarService } from './services/discover-left-sidebar.service';
import { TargetingSearchesService } from '../Targeting/services/targeting-searches.service';
import { TargetingSearchesApiService } from '../../api/targeting/targeting-searches.api.service';
import { TargetingListsApiService } from '../../api/targeting/targeting-lists.api.service';
import { TargetingListService } from '../Targeting/services/targeting-list.service';
import { JournodexEnumsService } from './services/journodex-enums.service';
import { ContactsPublicApi } from '../../api/targeting/contacts-public.api';
import { TargetingPreferencesApi } from '../../api/targeting/targeting-preferences.api';
import { DistributionService } from '../../Common/TargetingShared/services/distribution.service';
import { DistributionApi } from '../../api/distributions/distribution.api';
import { OutletsPublicApi } from '../../api/targeting/outlets-public.api';
import { AbstractPageBuilderService } from '../../Common/PageBuilder/services/abstract-page-builder.service';
import { TargetingMiscApi } from '../../api/targeting/targeting-misc.api';
import { InfluencerStreamsApi } from '../../api/targeting/influencer-streams.api';
import { InteractionViewApi } from '../../api/targeting/interaction-view.api';
import { TargetingQuotaApi } from '../../api/targeting/targeting-quota.api';
import { DistributionTemplateService } from '../../Common/TargetingShared/services/distribution-template.service';
import { DiscoverLeftSidebarManagementService } from './services/discover-left-sidebar-management.service';
import { CommonFormsModule } from '../../Common/Forms/forms.module';

@NgModule({
    imports: [
        LayoutModule,
        LocalizationModule,
        MiscModule,
        CommonFormsModule
    ],
    declarations: [
        DiscoverComponent
    ],
    exports: [
        DiscoverComponent
    ],
    providers: [
        DiscoverLeftSidebarService,
        TargetingSearchesService,
        TargetingSearchesApiService,
        TargetingListService,
        {
            provide: 'TargetingListService',
            useExisting: TargetingListService
        },
        TargetingListsApiService,
        JournodexEnumsService,
        ContactsPublicApi,
        TargetingPreferencesApi,
        TargetingQuotaApi,
        DistributionService,
        DistributionTemplateService,
        {
            provide: AbstractPageBuilderService,
            useExisting: DistributionService
        },
        {
            provide: 'DistributionService',
            useExisting: DistributionService
        },
        DistributionApi,
        OutletsPublicApi,
        TargetingMiscApi,
        InfluencerStreamsApi,
        InteractionViewApi,
        DiscoverLeftSidebarManagementService
    ]
})
export class DiscoverCoreModule { }
